import { onConnect } from '@reatom/framework'

import { reatomRequest } from '@root/shared/lib'

import { getGithubUserProfileRequestAction } from './get-github-user-profile-request-action'

export const githubUserProfile = (options: { username: string }) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const requestModel = reatomRequest({
    execAction: getGithubUserProfileRequestAction,
    prepare: () => ({
      username: options.username,
    }),
  })

  onConnect(requestModel, (ctx) => {
    requestModel.execute(ctx)
  })

  return { requestModel }
}
